import { get, isEmpty } from 'lodash';
import {
  symlinksPropName,
  symlinkToPropertyName,
  symlinkFromPropertyName,
  symlinkPathPropertyName,
  symlinksPropertiesPropName,
} from 'APP_ROOT/utils/create-symlink';

const filterValidRepeaterItems = items =>
  Array.isArray(items) ? items.filter(item => item && item.id) : items;

const getRepeaterPropsForAutoSave = (changedFields, data) => {
  const isCTR = get(data, '__assignedSections', false);
  if (isCTR) {
    return getRepeaterPropsForAutoSaveCTR(changedFields, data);
  }
  const [repeaterKey] = Object.keys(changedFields);
  const { [symlinksPropName]: symlinks = [] } = data;
  let repeaterData;
  const { [symlinkFromPropertyName]: from } =
    symlinks.find(s => s[symlinkToPropertyName] === repeaterKey) || {};
  if (from) {
    repeaterData = {
      [from]: get(data, from),
      [symlinksPropName]: symlinks,
    };
  }
  return { [repeaterKey]: filterValidRepeaterItems(get(data, repeaterKey)), ...repeaterData };
};

/**
 * CTR requires all children to be added to the auto save payload
 */
const getRepeaterPropsForAutoSaveCTR = (changedFields, data) => {
  const [repeaterKey] = Object.keys(changedFields);
  const { [symlinksPropName]: symlinks = [] } = data;
  const allData = {
    [repeaterKey]: get(data, repeaterKey),
  };
  const [item] = allData[repeaterKey];
  // props for parent repeater
  // path for child repeater
  const {
    [symlinksPropertiesPropName]: props = [],
    [symlinkPathPropertyName]: path,
  } = item;
  //
  const { [symlinkFromPropertyName]: from } =
    symlinks.find(s => s[symlinkPathPropertyName] === path) || {};
  if (from) {
    // get parent repeater data
    allData[from] = get(data, from);
  }
  // get children reference from parent if any
  const parentProps = get(data, [from, 0, symlinksPropertiesPropName], []);
  // add all the children repeaters together
  const allProps = [...props, ...parentProps];
  // get all the data for those repeaters
  allProps.forEach(prop => {
    allData[prop] = get(data, prop);
  });
  if (!isEmpty(allProps)) {
    allData[symlinksPropName] = symlinks;
  }
  // Filter out incomplete items (no id) from all repeater arrays
  Object.keys(allData).forEach(key => {
    if (key !== symlinksPropName) {
      allData[key] = filterValidRepeaterItems(allData[key]);
    }
  });
  return allData;
};

export default getRepeaterPropsForAutoSave;
